import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import AttendanceView from "./AttendanceView";
import "./verifierdasdhboard.css";

const VerifierDashboard = (props) => {
  const [activeComponent, setActiveComponent] = useState("attendance");

  const goBackToList = () => {
    if (props && props.history && typeof props.history.push === "function") {
      props.history.push("/patient-list");
    }
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "attendance":
        return <AttendanceView />;
      default:
        return (
          <p>
            Welcome to the Verifier Dashboard. Select an option from the sidebar
            to view details.
          </p>
        );
    }
  };

  // Attendance is the only view: login/logout/break/worked/activity plus
  // files & patients verified per range (Today / Week / Month / Custom).
  const tabs = [
    {
      key: "attendance",
      label: "Attendance",
      desc:
        "Login, logout, break, worked hours, files & patients verified in Today / Week / Month / Custom views",
    },
  ];

  const activeTab = tabs.find((t) => t.key === activeComponent);

  return (
    <div className="dashboard-container dark-theme">
      <div className="sidebar">
        <div>
          <div className="sidebar-title">Verifier Dashboard</div>
          <nav>
            <ul>
              {tabs.map((tab) => (
                <li key={tab.key}>
                  <button
                    type="button"
                    onClick={() => setActiveComponent(tab.key)}
                    className={
                      "nav-link " +
                      (activeComponent === tab.key ? "active" : "")
                    }
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="sidebar-bottom">
          <button className="back-button" onClick={goBackToList}>
            Back
          </button>
        </div>
      </div>

      <div className="main-content">
        <div className="vd-page-header">
          <h2>{activeTab ? activeTab.label : "Verifier Dashboard"}</h2>
          <p>
            {activeTab ? activeTab.desc : "Select a section from the sidebar"}
          </p>
        </div>
        <main>{renderComponent()}</main>
      </div>
    </div>
  );
};

export default withRouter(VerifierDashboard);
